export default "__VITE_ASSET__CcTNi61I__"